import { Group, Text, Tooltip } from "@mantine/core"
import { forwardRef } from "react"

import { useTextOverflow, Asterisk } from "@tfg/ui"

import styles from "./Label.module.css"

type LabelProps = {
  disabledTooltip?: boolean
  label: string
  labelClassName?: string
  size?: "xs" | "sm" | "md" | "lg"
  withAsterisk?: boolean
}

export const Label = forwardRef<HTMLDivElement, LabelProps>(
  (
    {
      disabledTooltip = false,
      label,
      labelClassName,
      size = "xs",
      withAsterisk = false,
    },
    ref
  ) => {
    const { textRef, isOverflowing } = useTextOverflow()

    return (
      <Tooltip
        label={label}
        disabled={disabledTooltip || !isOverflowing}
        ref={ref}
      >
        <Group
          className={styles.labelWithEllipsis}
          maw="100%"
          gap={2}
          wrap="nowrap"
        >
          <Text
            size={size}
            className={labelClassName}
            truncate="end"
            ref={textRef}
          >
            {label}
          </Text>
          {withAsterisk && <Asterisk />}
        </Group>
      </Tooltip>
    )
  }
)
